exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input.ng-valid {\n  border: 1px solid rgba(40, 167, 69, 0.5) !important;\n  border-left: 2px solid #28a745 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/input-time/components/input-time/input-time.component.scss
// module id = 2189
// module chunks = 66